module.exports = __webpack_public_path__ + "img/chat-box-online-btn-117x88.7c28312e.png";